/**---------------------------------------------------------------------
 * Load in production only
 */
if (Mobi2Go.app.base_url === 'https://www.mobi2go.com') {
    Mobi2Go.onReady(load);
}

function load() {
    let inspectlet_id = Mobi2Go.headoffice.analytics_inspectlet_id;

    if (inspectlet_id === 'default') {
        inspectlet_id = 1741257077;
    }

    if (!inspectlet_id) {
        return;
    }

    /**---------------------------------------------------------------------
     * Install script
     */
    window.__insp = window.__insp || [];
    __insp.push(['wid', inspectlet_id]);
    (function() {
        function __ldinsp() {
            const insp = document.createElement('script');
            insp.type = 'text/javascript';
            insp.async = true;
            insp.id = 'inspsync';
            insp.src = `${
                document.location.protocol == 'https:' ? 'https' : 'http'
            }://cdn.inspectlet.com/inspectlet.js`;
            const x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(insp, x);
        }
        if (window.attachEvent) {
            window.attachEvent('onload', __ldinsp);
        } else {
            window.addEventListener('load', __ldinsp, false);
        }
    })();

    /**---------------------------------------------------------------------
     * Tags
     */
    tag({
        ui: Mobi2Go.app.ui_name,
        headoffice_id: Mobi2Go.headoffice.id,
        headoffice_name: Mobi2Go.headoffice.display_name,
    });

    Mobi2Go.Order.bind({
        updateId(id) {
            tag({
                id,
            });
        },
        updateCustomer(customer) {
            customer &&
                tag({
                    customer_id: customer.id,
                    customer_name: customer.name,
                    customer_email: customer.email,
                });
        },
        updateLocation(location) {
            location &&
                tag({
                    location_id: location.id,
                    location_name: location.name,
                });
        },
        updateMethod(method) {
            tag({
                method,
            });
        },
        updatePaymentMethod(method) {
            tag({
                payment_method: method,
            });
        },
        updateProgressPhase(phase) {
            tag({
                progress_phase: phase,
            });
        },
        updateProgressStatus(status) {
            tag({
                progress_status: status,
            });
        },
        updateProgressMessage(message) {
            tag({
                progress_message: message,
            });
        },
    });
}

/**-------------------------------------------------------------------------
 * Tag helper
 */
function tag(data) {
    window.__insp.push(['tagSession', data]);
}
